<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="RefuseReqVO" ref="queryForm" label-width="auto" size="small" inline>
        <div class="query-grid">

          <!-- 开始时间 -->
          <el-form-item :label="$t('initTradeRecordPage.startDate')" prop="startDate">
            <el-date-picker
                v-model="RefuseReqVO.startDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                class="full-width"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>

          <!-- 结束时间 -->
          <el-form-item :label="$t('initTradeRecordPage.endDate')" prop="endDate">
            <el-date-picker
                v-model="RefuseReqVO.endDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                class="full-width"
                :clearable="false"
                :editable="false"
            />
          </el-form-item>

          <!-- 流水订单号 -->
          <el-form-item :label="$t('initTradeRecordPage.randomOrderno')" prop="upTrNo">
            <div class="input-with-more">
              <el-input v-model="RefuseReqVO.upTrNo" clearable />
            </div>
          </el-form-item>


          <!-- 支付状态 -->
          <el-form-item :label="$t('initTradeRecordPage.paymentState')" prop="trStatus">
            <el-select v-model="RefuseReqVO.trStatus" clearable filterable class="full-width">

              <el-option :label="$t('initTradeRecordPage.noConfirm')" value="-2" />
              <el-option :label="$t('initTradeRecordPage.noProcess')" value="-1" />
              <el-option :label="$t('initTradeRecordPage.fail')" value="0" />
              <el-option :label="$t('initTradeRecordPage.success')" value="1" />
            </el-select>
          </el-form-item>

          <!-- 时间类型 -->
          <el-form-item :label="$t('initTradeRecordPage.TimeType')" prop="dateType">
            <el-select v-model="RefuseReqVO.dateType" filterable class="full-width">

              <el-option :label="$t('initTradeRecordPage.tradeTime')" value="0" />
              <el-option :label="$t('initTradeRecordPage.congealtime')" value="1" />
              <el-option :label="$t('initTradeRecordPage.protesttime')" value="2" />
              <el-option :label="$t('initTradeRecordPage.cpdtime')" value="3" />
              <el-option :label="$t('initTradeRecordPage.appDate')" value="4" />
            </el-select>
          </el-form-item>

          <!-- 商户订单号 -->
          <el-form-item :label="$t('initTradeRecordPage.businessOrderno')" prop="trMerOrderno">
            <div class="input-with-more">
              <el-input v-model="RefuseReqVO.trMerOrderno" clearable />
            </div>
          </el-form-item>

          <!-- 申诉状态 -->
          <el-form-item :label="$t('initTradeRecordPage.trIsexplain')" prop="upExpStatus">
            <el-select v-model="RefuseReqVO.upExpStatus" clearable filterable class="full-width">

              <el-option :label="$t('initTradeRecordPage.failed')" value="0" />
              <el-option :label="$t('initTradeRecordPage.success')" value="1" />
              <el-option :label="$t('initTradeRecordPage.explaing')" value="2" />
            </el-select>
          </el-form-item>

          <!-- 是否申诉 -->
          <el-form-item :label="$t('initTradeRecordPage.isExp')" prop="upIsExp">
            <el-select v-model="RefuseReqVO.upIsExp" clearable filterable class="full-width">

              <el-option :label="$t('initTradeRecordPage.yes')" value="1" />
              <el-option :label="$t('initTradeRecordPage.no')" value="0" />
            </el-select>
          </el-form-item>


          <el-form-item :label="$t('initTradeRecordPage.upExpType')" prop="upExpType">
            <el-select v-model="RefuseReqVO.upExpType" clearable filterable class="full-width">

              <el-option :label="$t('initTradeRecordPage.upExpType1')" value="1" />
              <el-option :label="$t('initTradeRecordPage.upExpType2')" value="2" />
            </el-select>
          </el-form-item>


          <el-form-item class="btn-row" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </div>
      </el-form>

      <!-- More 弹窗保持不变 -->
      <el-dialog :visible.sync="moreDialogVisible" width="800px" @close="onMoreDialogClose">
        <el-input
            type="textarea" :rows="8" v-model="moreInput"
            placeholder="请输入多个值，使用英文逗号隔开，最多1000个值。例如：&#10;VALUE1&#10;VALUE2, VALUE3"
        />
        <span slot="footer">
        <el-button @click="closeMoreDialog">取消</el-button>
        <el-button type="primary" @click="confirmMoreInput">确定</el-button>
      </span>
      </el-dialog>
    </el-card>


    <div class="action-toolbar">
      <el-button
          v-if="hasPermission( 'merTradeMgr/initProConTradePage','downExcel')"
          :disabled="!hasSearched"
          :loading="downloadLoading"
          @click="handledownload"
          type="primary"
          icon="el-icon-download"
      >
        {{$t('button.download')}}
      </el-button>



    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

<!--        <el-table-column

            width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
                v-model="selectedRowId"
                :label="scope.row.trNo"
                @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>-->

        <el-table-column prop="gwNo1" :label="$t('initTradeRecordPage.gatewayNo')" :min-width="columnWidths.gatewayNo"></el-table-column>
        <el-table-column prop="trNo" :label="$t('initTradeRecordPage.randomOrderno')" width="210"></el-table-column>
        <el-table-column prop="trMerOrderno" :label="$t('initTradeRecordPage.businessOrderno')" width="210"></el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.tradeMoney')" :min-width="columnWidths.tradeMoney">
          <template #default="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trAmount) }}</span>
          </template>
        </el-table-column>



        <el-table-column :label="$t('initTradeRecordPage.protectMoney')" :min-width="columnWidths.protectMoney">
          <template #default="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.reseverAmount)}}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('initTradeRecordPage.isOrNotFreeze')" :min-width="columnWidths.isOrNotFreeze">
          <template slot-scope="scope">
            <span v-if="scope.row.trCongeal === 0">{{$t('initTradeRecordPage.no')}}</span>
            <span v-else-if="scope.row.trCongeal === 1" style="color: red;">{{$t('initTradeRecordPage.yes')}}</span>

          </template>
        </el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.congealamout')" :min-width="columnWidths.congealamout">
          <template slot-scope="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trCongealAmount) }}</span>
          </template>
        </el-table-column>


        <el-table-column :label="$t('initTradeRecordPage.isOrNotRefusalPayment')" min-width="120">
          <template slot-scope="scope">
                <span v-if="scope.row.trProtest === 1 || (scope.row.trCongeal === 0 && scope.row.trRefChaProFlag === 1)">

                  <span style="color: red;">{{$t('initTradeRecordPage.yes')}}</span>

                  <span v-if="scope.row.trRefChaProFlag === 1" style="color: red;">{{$t('initTradeRecordPage.refchapro')}}</span>

                </span>

            <span v-else-if="scope.row.trProtest === 0">
                  {{$t('initTradeRecordPage.no')}}
                </span>

          </template>
        </el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.protestamout')" :min-width="columnWidths.protestamout">
          <template slot-scope="scope">
            <span>{{ scope.row.trCurrency }} {{ formatMoney(scope.row.trProtestAmount) }}</span>
          </template>
        </el-table-column>


        <el-table-column  :label="$t('initTradeRecordPage.isExp')" :min-width="columnWidths.isExp">
          <template slot-scope="scope">
            <span v-if="scope.row.upIsExp === 0">{{$t('initTradeRecordPage.no')}}</span>
            <span v-else-if="scope.row.upIsExp === 1" style="color: red;">{{$t('initTradeRecordPage.yes')}}</span>

          </template>
        </el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.expStatus')" :min-width="columnWidths.expStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.expStatus === '7'">{{$t('initTradeRecordPage.expStatus7')}}</span>

            <span v-else-if="scope.row.expStatus === '8'">{{$t('initTradeRecordPage.expStatus8')}}</span>

            <span v-else-if="scope.row.expStatus === '9'" >{{$t('initTradeRecordPage.expStatus9')}}</span>

          </template>
        </el-table-column>

        <el-table-column :label="$t('initTradeRecordPage.expAmount')" :min-width="columnWidths.expAmount">
          <template slot-scope="scope">
          <span v-if="['7', '8', '9'].includes(scope.row.expStatus)">
            {{ scope.row.trCurrency }}
            {{ formatMoney(scope.row.expAmout) }}
          </span>
          </template>
        </el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.upExpType')" :min-width="columnWidths.upExpType">
          <template slot-scope="scope">
            <span v-if="['7', '8', '9'].includes(scope.row.expStatus)">
            <span v-if="scope.row.upExpType === 1">{{$t('initTradeRecordPage.upExpType1')}}</span>
            <span v-else-if="scope.row.upExpType === 2" style="color: red;">{{$t('initTradeRecordPage.upExpType2')}}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('initTradeRecordPage.expFailReson')" :min-width="columnWidths.expFailReson">
          <template #default="scope">
          <span v-if="scope.row.expStatus === '7'">
            {{ scope.row.expReason }}
          </span>
          </template>
        </el-table-column>





        <el-table-column :label="$t('initTradeRecordPage.paymentState')" :min-width="columnWidths.paymentState">
          <template slot-scope="scope">
              <span v-if="scope.row.trStatus === -2">{{$t('initTradeRecordPage.tradeState1')}}</span>

              <span v-else-if="scope.row.trStatus === -1">{{$t('initTradeRecordPage.tradeState2')}}</span>

              <span v-else-if="scope.row.trStatus === 0" style="color: red;">{{$t('initTradeRecordPage.tradeState3')}}</span>

              <span v-else-if="scope.row.trStatus === 1">{{$t('initTradeRecordPage.tradeState4')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="trBankinfo" :label="$t('initTradeRecordPage.backinfo')" :min-width="columnWidths.backinfo"></el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.appropriationState')" :min-width="columnWidths.appropriationState">
          <template slot-scope="scope">
            <span v-if="scope.row.trTsStatus === 0">{{$t('initTradeRecordPage.appropriationState1')}}</span>

            <span v-else-if="scope.row.trTsStatus === 1">{{$t('initTradeRecordPage.appropriationState2')}}</span>

            <span v-else-if="scope.row.trTsStatus === 2" >{{$t('initTradeRecordPage.appropriationState3')}}</span>

          </template>
        </el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.trRsStatus')" :min-width="columnWidths.trRsStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.trRsStatus === 0">{{$t('initTradeRecordPage.appropriationState1')}}</span>

            <span v-else-if="scope.row.trRsStatus === 1">{{$t('initTradeRecordPage.appropriationState2')}}</span>

            <span v-else-if="scope.row.trRsStatus === 2" >{{$t('initTradeRecordPage.appropriationState3')}}</span>

          </template>
        </el-table-column>


        <el-table-column prop="trDatetime" :label="$t('initTradeRecordPage.tradeTime')" width="210"></el-table-column>

        <el-table-column :label="$t('initTradeRecordPage.congealtime')" width="210">
          <template slot-scope="scope">
            <span v-if="RefuseReqVO.dateType === '0' && scope.row.freezeDate">
              {{ (scope.row.freezeDate) }}
            </span>
                    <span v-else-if="RefuseReqVO.dateType === '1' && scope.row.protestDate">
<!--              {{ (scope.row.expDate) }}-->
                      {{ (scope.row.protestDate) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column  :label="$t('initTradeRecordPage.protesttime')" width="210">
          <template slot-scope="scope">
            <span v-if="RefuseReqVO.dateType === '0' && scope.row.protestDate">
              {{ (scope.row.protestDate) }}
            </span>
            <span v-else-if="RefuseReqVO.dateType === '2' && scope.row.protestDate">
<!--              {{ (scope.row.expDate) }}-->
               {{ (scope.row.protestDate) }}
            </span>
            <span v-else-if="RefuseReqVO.dateType === '3' && scope.row.protestDate">
<!--              {{ (scope.row.expDate) }}-->
               {{ (scope.row.protestDate) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('initTradeRecordPage.upReason')" :min-width="columnWidths.upReason" show-overflow-tooltip>
          <template #default="scope">
            <span v-if="scope.row.upType === 2">
              {{ scope.row.upReason }}
            </span>
                    <span v-else>{{ scope.row.upReason }}</span>
                  </template>
        </el-table-column>

        <el-table-column prop="upCpdTime" :label="$t('initTradeRecordPage.cpdtime')" width="210"></el-table-column>
        <el-table-column prop="upExpTime" :label="$t('initTradeRecordPage.appDate')" width="210"></el-table-column>



      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 16px; text-align: right;"
      />
    </el-card>




  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {

      commonLabelStyle: {
        width: '180px',
        minWidth: '150px',
        textAlign: 'center',  // 文字居中
        wordBreak: 'break-all'
      },
      // 内容区也居中
      commonContentStyle: {
        textAlign: 'center'
      },
      RefuseReqVO: {
        upTrNo:"",
        trMerOrderno:"",
        dateType:"0",
        trStatus:"",
        startDate:"",
        endDate:"",
        upIsExp:"",
        upExpType:"",
        upExpStatus:"",
        gatewayNo:"",
      },
      columnWidths:{},
      downloadLoading:false,
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，
      hasSearched: false,   //  是否有进行查询
      timeList: [],
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    this.setDefaultTime(); //时间设置
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  watch:{
  },
  methods: {
    // 金额格式化：千分位 + 强制保留两位小数
    formatMoney(value) {
      if (!value) return "0.00";

      // 使用原生的 toLocaleString 方法实现 #,##0.00 的效果
      return Number(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // 下载
    async handledownload() {
      // 防止重复点击
      if (this.downloadLoading) return;
      this.downloadLoading = true;
      this.$message.info(this.$t('DownloadInfo'));
      try {

        const params = {
          upTrNo : this.RefuseReqVO.upTrNo || undefined,
          trMerOrderno : this.RefuseReqVO.trMerOrderno || undefined,
          dateType : this.RefuseReqVO.dateType || undefined,
          trStatus : this.RefuseReqVO.trStatus || undefined,
          startDate : this.RefuseReqVO.startDate || undefined,
          endDate : this.RefuseReqVO.endDate || undefined,
          upIsExp : this.RefuseReqVO.upIsExp || undefined,
          upExpType : this.RefuseReqVO.upExpType || undefined,
          upExpStatus : this.RefuseReqVO.upExpStatus || undefined,
          gatewayNo : this.RefuseReqVO.gatewayNo || undefined,



        };


        const res = await this.$axios.post('/api/unnormal/refuse/export', params, {
          responseType: 'blob'
        });

        //
        if (res.data.type === 'application/json' || (res.headers['content-type'] && res.headers['content-type'].includes('application/json'))) {
          const reader = new FileReader();
          reader.onload = () => {
            const errorData = JSON.parse(reader.result);
            this.$message.error(errorData.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }

        // 构造 Blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });

        if (res.headers['x-export-truncated'] === 'true') {
          const original = res.headers['x-export-original-size'];
          const exported = res.headers['x-exported-size'];
          const warningText = this.$t('export_truncated_warning').replace('{exported}', exported).replace('{original}', original);
          this.$message.warning(warningText);
        }

        //从请求头 Content-Disposition 中获取文件名 (需要后端配合暴露该 Header，否则使用默认值)
        let fileName = `拒付交易查询_${new Date().getTime()}.xlsx`;
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes('attachment')) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            // 解决中文乱码问题
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
          }
        }

        // 创建隐藏的 <a> 标签实现下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        // 清理资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href); // 释放掉blob对象

        this.$message.success(this.$t('export_success'));
      } catch (err) {
        console.error('导出Excel失败:', err);
        this.$message.error(this.$t('export_fail'));
      } finally {
        this.downloadLoading = false;
      }
    },
    hasPermission,
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.RefuseReqVO.startDate) {
        this.RefuseReqVO.startDate = this.getDefaultStartTime();
      }
      if (!this.RefuseReqVO.endDate) {
        this.RefuseReqVO.endDate = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(0, 0, 0, 0); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },


    // 分页：每页条数变化
    handleSizeChange(val) {
      /*  this.pagination.size = val;
        this.filterData();*/
      this.pagination.size = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      /* this.pagination.page = val;
       this.filterData();*/

      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 数据绑定
    handleRadioChange(row) {
      this.currentRow = row;
      this.selectedRowId = row.trNo;
    },
    // 查询
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          upTrNo : this.RefuseReqVO.upTrNo || undefined,
          trMerOrderno : this.RefuseReqVO.trMerOrderno || undefined,
          dateType : this.RefuseReqVO.dateType || undefined,
          trStatus : this.RefuseReqVO.trStatus || undefined,
          startDate : this.RefuseReqVO.startDate || undefined,
          endDate : this.RefuseReqVO.endDate || undefined,
          upIsExp : this.RefuseReqVO.upIsExp || undefined,
          upExpType : this.RefuseReqVO.upExpType || undefined,
          upExpStatus : this.RefuseReqVO.upExpStatus || undefined,
          gatewayNo : this.RefuseReqVO.gatewayNo || undefined,



          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/unnormal/refusePage',  params );

        if (res.data.code === 0) {

          this.currentRow = "";
          this.selectedRowId = "";

          const responseData = res.data.data;


          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },

    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.RefuseReqVO[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },

    /* confirmMoreInput() {
       this.queryParams[this.currentField] = this.moreInput; // ✅ 完全原样保存
       this.closeMoreDialog();
     },*/
    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
          .split(',')
          .map(item => item.trim())  // 去掉每个值的前后空格
          .filter(item => item.length > 0)  // 过滤空值
          .join(',');  // 用 # 重新连接

      this.RefuseReqVO[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

    // 表头宽度
    initColumnWidths() {
      const cols = [
        "gatewayNo",
        "businessOrderno",
        "tradeMoney",
        "protectMoney",
        "isOrNotFreeze",
        "congealamout",
        "protestamout",
        "isExp",
        "expStatus",
        "expAmount",
        "upExpType",
        "expFailReson",
        "paymentState",
        "backinfo",
        "appropriationState",
        "trRsStatus",
        "tradeTime",
        "congealtime",
        "protesttime",
        "upReason",
        "cpdtime",
        "appDate",


      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
            `initTradeRecordPage.${key}`
        );

        this.$set(
            this.columnWidths,
            key,
            Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }

  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>


<style scoped>
/* 查询卡片 */
.query-card {
  padding: 20px 24px !important;
 /* margin: 20px 24px 0 !important;*/
}

/* 三列铺满整个卡片 */
.query-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  /*column-gap: 80px;*/
  column-gap: clamp(24px, 5vw, 80px);
  row-gap: 0;
  width: 100%;
}

/* 每个查询条件 */
.query-card /deep/ .el-form-item {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 18px !important;
}

/* 标签 */
.query-card /deep/ .el-form-item__label {
  width: auto !important;
  min-width: 90px;

  flex-shrink: 0;
  white-space: nowrap !important;

  text-align: right !important;

  font-weight: 700 !important;
  color: #303133 !important;
  font-size: 14px !important;

  padding-right: 10px !important;
}

/* 输入控件区域 */
.query-card /deep/ .el-form-item__content {
  flex: 0 0 180px;
  width: 200px;

  margin-left: 0 !important;
  padding-left: 0 !important;
  min-width: 0;
}

/* 输入框 */
.query-card /deep/ .el-input,
.query-card /deep/ .el-select,
.query-card /deep/ .el-date-editor {
  width: 200px !important;
}

/* 输入框内部文字左对齐 */
.query-card /deep/ .el-input__inner {
  text-align: left !important;
  font-weight: 500 !important;
  color: #303133 !important;
  border-radius: 6px !important;
}

/* 下拉框文字 */
.query-card /deep/ .el-select .el-input__inner {
  text-align: left !important;
}

/* 日期 */
.query-card /deep/ .el-date-editor .el-input__inner {
  text-align: left !important;
}

/* placeholder */
.query-card /deep/ .el-input__inner::placeholder {
  text-align: left !important;
  font-weight: 400 !important;
  color: #c0c4cc !important;
}

/* More */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: none !important;
  width: 200px !important;
}

/* 按钮独占一行 */
.btn-row {
  grid-column: 1 / -1;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 20px !important;
  margin-bottom: 0 !important;
}

/* 按钮 */
.btn-row ::v-deep .el-button {
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 10px 24px !important;
  border-radius: 6px !important;
  min-width: 80px;
}
/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}
.table-card ::v-deep .el-table {
  min-width: 100%;
}
.order-list {
  padding: 20px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .query-grid {
    column-gap: 30px;
  }
}

@media (max-width: 992px) {
  .query-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .query-grid {
    grid-template-columns: 1fr;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/merTradeMgr/initProConTradePage.vue